/*import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-denunciasdh',
  templateUrl: './denunciasdh.component.html',
  styleUrls: ['./denunciasdh.component.css']
})
export class DenunciasdhComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}*/


import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';

import { Perfil } from '../perfil/perfil';
import { PerfilService } from '../perfil/perfil.service';

import { Vinculo } from '../vinculo/vinculo';
import { VinculoService } from '../vinculo/vinculo.service';

import { Incidente } from '../incidente/incidente';
import { IncidenteService } from '../incidente/incidente.service';

import { Comunicado } from '../comunicado/comunicado';
import { ComunicadoService } from '../comunicado/comunicado.service';

import { RelacaoIncidente } from '../relacao-incidente/relacao-incidente';
import { RelacaoIncidenteService } from '../relacao-incidente/relacao-incidente.service';

import { Denuncia } from '../denuncia/denuncia';
import { DenunciaService } from '../denuncia/denuncia.service';

import { RequestOptions, Headers, Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';

import {  FileUploader } from 'ng2-file-upload/ng2-file-upload';

import { URL_API } from './../constante';

const URL = URL_API + '/upload';

@Component({
  selector: 'app-denunciasdh',
  templateUrl: './denunciasdh.component.html',
  styleUrls: ['./denunciasdh.component.css'],
  providers: [
    PerfilService,
    VinculoService,
    IncidenteService,
    ComunicadoService,
    RelacaoIncidenteService,
    DenunciaService,
  ]
})
export class DenunciasdhComponent implements OnInit {

  outroPerfil: boolean;
  outroVinculo: boolean;
  outroIncidente: boolean;
  outroComunicado: boolean;
  outroRelacao: boolean;
  opcaoComun: boolean;

  anonimoDenunciante: boolean;
  opcaoPerfilDenunciante: number;
  opcaoVinculoDenunciante: number;
  opcaoTipoIncidente: number;
  opcaoCominucacaoOutro: number;

  perfis: Perfil[];
  vinculos: Vinculo[];
  incidentes: Incidente[];
  comunicados: Comunicado[];
  relacoes: RelacaoIncidente[];

  denuncia: Denuncia;

  itensRelIncidente = [];
  itensTipoIncidente = [];
  itensTipoComunicado = [];

  // mascara data e hora do incidente
  public maskDHInc = [/[0-3]/, /\d/, '/', /[0-1]/, /\d/, '/', /[1-2]/, /\d/, /\d/, /\d/, ' ', /[0-1-2]/, /\d/, ':', /[0-5]/, /\d/, ':', /[0-5]/, /\d/]

  public uploader:FileUploader = new FileUploader({url: URL, itemAlias: 'arquivo'});

  nomeFakeArquivo: string;

  constructor(
    private perfilService: PerfilService,
    private vinculoService: VinculoService,
    private incidenteService: IncidenteService,
    private comunicadoService: ComunicadoService,
    private relacaoService: RelacaoIncidenteService,
    private denunciaService: DenunciaService,
    private route: ActivatedRoute,
    private location: Location,
    private router: Router,
    private http: Http
  ) {
    this.denuncia = new Denuncia;
    this.anonimoDenunciante = false;

    this.http = http;
  }

  getPerfis(): void {
    this.perfilService.getPerfis()
    .then(perfil => this.perfis = perfil);
  }
  getVinculos(): void {
    this.vinculoService.getVinculos()
    .then(vinculo => this.vinculos = vinculo);
  }
  getIncidentes(): void {
    this.incidenteService.getIncidentes()
    .then(incidente => this.incidentes = incidente);
  }
  getComunicados(): void {
    this.comunicadoService.getComunicados()
    .then(comunicado => this.comunicados = comunicado);
  }
  getRelacoes(): void {
    this.relacaoService.getRelacoes()
    .then(relacao => this.relacoes = relacao);
  }

  subOutroPerfil(bool: boolean) {
    this.outroPerfil = bool;
  }
  subOutroVinculo(bool: boolean) {
    this.outroVinculo = bool;
  }

  /*subOutroIncidente(bool: boolean) {
    this.outroIncidente = bool;
  }*/

  subOutroIncidente() {
    this.outroIncidente = !this.outroIncidente;
  }

  /*subOutroComunicado(bool: boolean) {
    this.outroComunicado = bool;
  }*/

  subOutroComunicado() {
    this.outroComunicado = !this.outroComunicado;
  }
  subOutroRelacao() {
    this.outroRelacao = !this.outroRelacao;
  }
  subOpcaoComun(bool: boolean) {
    this.opcaoComun = bool;
  }

  selRelacaoIncidente(value,event){
    if (event.target.checked) {
      this.itensRelIncidente.push(value);
    }
    else if (!event.target.checked) {
      let indexx = this.itensRelIncidente.indexOf(value);
      this.itensRelIncidente.splice(indexx,1);
    }
    //console.log("CHECKBOX ");
    //console.log(this.itensRelIncidente);
  }

  selTipoIncidente(value,event){
    if (event.target.checked) {
      this.itensTipoIncidente.push(value);
    }
    else if (!event.target.checked) {
      let indexx = this.itensTipoIncidente.indexOf(value);
      this.itensTipoIncidente.splice(indexx,1);
    }
    //console.log("CHECKBOX TIPO ");
    //console.log(this.itensTipoIncidente);
  }


  selTipoComunicado(value,event){
      if (event.target.checked) {
        this.itensTipoComunicado.push(value);
      }
      else if (!event.target.checked) {
        let indexx = this.itensTipoComunicado.indexOf(value);
        this.itensTipoComunicado.splice(indexx,1);
      }
      //console.log("CHECKBOX COMUN ");
      //console.log(this.itensTipoComunicado);
  }

  ngOnInit() {
    // sobrescrevendo o metodo onAfterAddingFile, retirando a parte de verificacao de credenciais no upload
    this.uploader.onAfterAddingFile = (file)=> { file.withCredentials = false; };

    // sobrescrevendo o metodo onCompleteItem para lidar com a resposta do servidor (upload bem sucedido)
    this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {
            console.log("ImageUpload:uploaded:", item, status, response);
            alert('Arquivo gravado com sucesso!');
            this.nomeFakeArquivo = response; // nome do arquivo criptografado

    };

    this.outroPerfil = false;
    this.outroVinculo = false;
    this.outroIncidente = false;
    this.outroComunicado = false;
    this.outroRelacao = false;
    this.opcaoComun = false;

    this.getPerfis();
    this.getVinculos();
    this.getIncidentes();
    this.getComunicados();
    this.getRelacoes();
  }

  salvar(): void {
    if (this.anonimoDenunciante == true){
      this.denuncia.anonimoDenunciante = 1;
    } else if (this.anonimoDenunciante == false){
      this.denuncia.anonimoDenunciante = 0;
    }
    this.denuncia.chaveAcessoDenunciante = 'trueValue';
    //if(this.denuncia.descricao !== undefined && this.denuncia.envolvidos !== undefined && this.denuncia.relacaoEntreEnvolvidos !== undefined && this.denuncia.dataHoraIncidente !== undefined && this.denuncia.localIncidente !== undefined){

    // setando os ids dos itens relacao de incidente
    this.denuncia.DitensRelIncidente = this.itensRelIncidente;

    // setando os ids dos itens tipo de incidente
    this.denuncia.itensTipoIncidenteFinal = this.itensTipoIncidente;

    // setando os ids dos itens da comunicacao do incidente
    this.denuncia.itensTipoComunicadoFinal = this.itensTipoComunicado;

    // setando o nome do arquivo criptografado
    this.denuncia.nomeArquivo = this.nomeFakeArquivo;

      if (!this.denuncia.id) {
        this.denunciaService.saveDenuncia(this.denuncia)
            .then(() => this.goBack());
      }
      this.router.navigate(['/denuncias']);

    //}
  }

  goBack(): void {
     this.router.navigate(['inicio']);
  }

}



// WEBPACK FOOTER //
// ./src/app/denunciasdh/denunciasdh.component.ts